import React, { Component, Fragment } from 'react';
import { observer, inject } from 'mobx-react';
import { withRouter } from "react-router";
import { notification, Select, Button, Input, Descriptions } from 'antd';
import { COMPANY_TYPE } from 'constant';

@inject('orderStore')
@observer
class SelectDetail extends Component {
  state={
    detailGoods: null,
    goodsSize: '',
    goodsSizeCnt: 1,
    goodsCnt: "1",
    goodsEtc: '',
    reqReason: '',
    dresserNm: ''
  };

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.detailGoods !== this.props.detailGoods) {
      this.props.orderStore.orderGoodsList('','','', true);
      this.setState({ 
        detailGoods: nextProps.detailGoods,
        goodsSize: '',
        goodsSizeCnt: 1,
        goodsCnt: "1",
        goodsEtc: '',
        reqReason: '',
        dresserNm: ''
      });
    }
  }

  merCartInfo = () => {
    const { detailGoods, goodsSize, goodsCnt, goodsEtc, reqReason, dresserNm } = this.state;
    const { cGbn } = this.props;
    if (goodsSize === '') {
      notification.warning({placement: 'bottomLeft', message: `사이즈를 선택해주세요.`, duration: 2});
      return false;
    }

    if (goodsSize === "기타" && goodsEtc === '') {
      notification.warning({placement: 'bottomLeft', message: process.env.REACT_APP_ETCSIZE, duration: 2});
      return false;
    }

    if (goodsCnt === "0" || goodsCnt === '') {
      notification.warning({placement: 'bottomLeft', message: `주문수량을 확인해주세요.`, duration: 2});
      return false;
    }

    if ((cGbn === COMPANY_TYPE.BENZ) && dresserNm === '') {
      notification.warning({placement: 'bottomLeft', message: `사원명을 입력해주세요.`, duration: 2});
      return false;
    }
    
    // if (reqReason === '') {
    //   notification.warning({placement: 'bottomLeft', message: `신청사유를 입력해주세요.`, duration: 2});
    //   return false;
    // }
    
    let dataObj = {
      caUserId: "",
      pGdCd: detailGoods?.pGdCd || "",
      caGdCd: detailGoods.gdCd,
      caGdSize: goodsSize,
      caCnt: goodsCnt,
      caEtc: goodsEtc,
      reqReason: reqReason,
      dresserNm: dresserNm
    };
    
    this.props.orderStore.merCartInfo(dataObj);
    this.props.onSelect();
    
  };

  render() {
    const { detailGoods, goodsSize, goodsSizeCnt, goodsCnt, goodsEtc, dresserNm } = this.state;
    const { cGbn } = this.props;
    const maxValue = () => {
      let maxValue = "1";
      maxValue = parseInt(goodsSizeCnt)
      return parseInt(maxValue);
    }
    return (
      detailGoods !== null &&
      <Fragment>
        <h2>▶ 주문수량 및 주문 확인</h2>
        <div className="table_th_W_order">
          <Descriptions bordered>
            <Descriptions.Item label="상품명" span={3}>
              {detailGoods.gdNm !== undefined && detailGoods.gdNm !== null && detailGoods.gdNm}
            </Descriptions.Item>
            {(cGbn === COMPANY_TYPE.BENZ) && 
              <Descriptions.Item label="사원명" span={3}>
                <Input
                  placeholder={'사원명을 입력해주세요.'}
                  style={{ width: '100%', marginTop: 8 }}
                  value={dresserNm}
                  onChange={(e)=>this.setState({dresserNm: e.target.value})}
                />
              </Descriptions.Item>
            }
            <Descriptions.Item label="사이즈" span={3}>
              {detailGoods.gdSizeList !== undefined && detailGoods.gdSizeList !== null &&
              <Select
                style={{ width: '100%' }}
                placeholder="사이즈 선택"
                value={goodsSize}
                onChange={(value, option)=>{
                  // console.log("option", option);
                  this.setState({goodsSize: value, goodsEtc: '', goodsSizeCnt: parseInt(option.option.stCnt), goodsCnt: 1});
                }}
              >
                {detailGoods.gdSizeList.map(item=>{
                  return(
                  <Select.Option
                    disabled={item.stCnt === 0 ? true : false}
                    key={item.stSize}
                    option={item}
                  >{item.stSize} 재고:{item.stCnt}</Select.Option>
                  )
                })}
              </Select>
              }
              {goodsSize === "기타" &&
                <Input
                  placeholder={process.env.REACT_APP_ETCSIZE}
                  style={{ width: '100%', marginTop: 8 }}
                  value={goodsEtc}
                  onChange={(e)=>this.setState({goodsEtc: e.target.value})}
                />
              }
            </Descriptions.Item>
            <Descriptions.Item label="주문수량" span={3}>
              {(detailGoods !== null) && (
                (goodsSize !== '')
                ? <div>
                    <Button
                      onClick={()=>{
                        if (parseInt(goodsCnt) > 1) {
                          this.setState({goodsCnt: parseInt(goodsCnt) - 1});
                        }
                      }}
                    > - </Button>
                    <Input
                      placeholder="수량을 입력하세요"
                      value={goodsCnt}
                      onChange={(e)=>{
                        let value = e.target.value;
                        value = value.toString().replace(/[^0-9]/g, "");
                        if (maxValue() < parseInt(value)) {
                          notification.warning({placement: 'bottomLeft', message: `주문가능수량을 초과하여 최고가능수량(${maxValue()})으로 변경됩니다.`, duration: 2});
                          value = maxValue();
                        }
                        this.setState({goodsCnt: value});
                      }}
                      style={{ width: 40 }}
                    />
                    <Button
                      onClick={()=>{
                        if (parseInt(goodsCnt) < maxValue()) {
                          this.setState({goodsCnt: parseInt(goodsCnt) + 1});
                        }
                      }}
                    > + </Button>
                  </div>
                : <Fragment>사이즈를 선택해주세요.</Fragment>
              )}
            </Descriptions.Item>
            <Descriptions.Item label="금액" span={3}>
              {detailGoods !== null &&
              detailGoods.gdPrice !== undefined && detailGoods.gdPrice !== null && 
              detailGoods.gdPrice !== "" && (
                (parseInt(detailGoods.gdPrice) * goodsCnt).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              )}
            </Descriptions.Item>
          </Descriptions>
        </div>
        <Button
          className="table_ord_step03_btn"
          onClick={this.merCartInfo}
        >장바구니 추가</Button>
      </Fragment>
    );
    
  }
}

export default withRouter(SelectDetail);
